var mekrsSetting = {
  keyboardCustomButtons: {
    btnNebrat: { code: [0], title: 'NEBRAT', layout: ['alphabet'] },
    btnZinkovna: { code: [0], title: 'ZINKOVNA', layout: ['alphabet'] },
    btnBio: { code: [0], title: 'BIO', layout: ['alphabet'] }
  }
};

/*
 keyboard.addCustomButtons(mekrsSetting.keyboardCustomButtons);
 */
